import {
  FETCH_COMPANY_CONTACT_REQUEST,
  FETCH_COMPANY_CONTACT_FAILURE,
  FETCH_COMPANY_CONTACT_SUCCESS,
  FETCH_COUNTRIES_REQUEST,
  FETCH_COUNTRIES_FAILURE,
  FETCH_COUNTRIES_SUCCESS
} from '../constants/companyContact';

import { CompanyContactPayload } from '../interfaces/companyContact';
import { Actions } from '../actions/companyContact';
import { CommonState } from '@pec/aion-ui-core/slices/common';

export type State = CommonState & {
  companyContactData: CompanyContactPayload;
};

const initialState: State = {
  error: null,
  isFetching: false,
  companyContactData: {
    id: 0,
    accountId: '',
    administratorContact: {
      firstName: '',
      lastName: '',
      email: '',
      phone: ''
    },
    billingContact: {
      firstName: '',
      lastName: '',
      email: '',
      phone: ''
    },
    physicalAddress: {
      country: '',
      countryIso3: '',
      state: '',
      city: '',
      postalCode: '',
      address1: '',
      address2: ''
    },
    billingAddress: {
      country: '',
      countryIso3: '',
      state: '',
      city: '',
      postalCode: '',
      address1: '',
      address2: ''
    }
  }
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case FETCH_COMPANY_CONTACT_REQUEST:
    case FETCH_COUNTRIES_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_COMPANY_CONTACT_SUCCESS:
      return {
        isFetching: false,
        companyContactData: action.payload,
        error: null
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        isFetching: false
      };
    case FETCH_COMPANY_CONTACT_FAILURE:
    case FETCH_COUNTRIES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
